const {h, render, Component} = require('preact');
const {Portal} = require('preact-portal');
const Click2CallFormMainContainer = require('../../containers/click2call/click2call_form')
const ConfirmationPopup = require('../confirmation_popup/confirmation_popup')

class CallbackView extends Component {
  constructor(props) {
    super(props);
      this.state = {
          open: false
      }
      this.open = this.open.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
      this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
      this.handleCloseConfirmationPopup = this.handleCloseConfirmationPopup.bind(this);
      this.showPopUp = this.showPopUp.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  showPopUp(){
    if(event.detail.type=='callback'){
      this.setState({
        open: true, resetState: true
      });
    }
  }

  open() {
    if(document.getElementById("bc-layered-chat") || document.getElementById("bc-minimized-indicator"))
    {
      var event = new CustomEvent('channel-switch',{detail: {type:'callback'}});
      var channelsContainer = document.getElementsByClassName('all-channels')[0]
      if(channelsContainer)
      {
        channelsContainer.dispatchEvent(event);
        channelsContainer.addEventListener('show-popup', this.showPopUp, false);
      }
    }
    else{
      this.setState({
        open: true, resetState: true
      });
    }
  }

  handleClick() {
    this.setState({
      open: false, confirmationPopup: true, resetState: false
    });
  }

  handleBackButtonClick() {
    this.setState({
      open: true, confirmationPopup: false, resetState: false
    });
  }

  handleCloseButtonClick() {
    this.setState({
      open: false, resetState: true, confirmationPopup: false
    });
  }

  handleCloseConfirmationPopup() {
    this.setState({
      confirmationPopup: false,
      open: true,
      resetState: false
    })
  }

  getTranslationObject(){
    var translationObject = {}
    translationObject.closeText = I18n.translate('js.modules.web_2018.close_text_form')
    translationObject.selectingText = I18n.translate('js.modules.web_2018.selecting_text_callback')
    translationObject.sureText = I18n.translate('js.modules.web_2018.sure_text_callback')
    translationObject.backButtonText = I18n.translate('js.modules.web_2018.back_button_form')
    translationObject.closeButtonText = I18n.translate('js.modules.web_2018.close_button_form')
    return translationObject;
  }

  getPhoneIcon(phoneConfig){
    return (
      <div class={!phoneConfig.isAvailable ? 'channel-unavailable' : 'channel-available'} aria-label="PhoneButton" onClick={this.open}>
        <table class={!phoneConfig.isAvailable ? 'channel-grid  channel-unavailable' : 'channel-grid'} data-bhw={phoneConfig.bhw}>
          <tr>
            <td class="channel-icon-section">
              <span class={!phoneConfig.isAvailable ? 'icon-mobile channel-icon  channel-unavailable' : 'icon-mobile channel-icon'}></span>
            </td>
            <td class="channel-text-section">
              <span class={!phoneConfig.isAvailable ? 'channel-text  channel-unavailable' : 'channel-text'}>{phoneConfig.channelText}</span><br></br>
              <span class={!phoneConfig.isAvailable ? 'channel-msg  channel-unavailable' : 'channel-msg'}>{phoneConfig.channelMsg}</span>
            </td>
          </tr>
        </table>
      </div>
    );
  }

  getPhoneLink(phoneConfig){
    let unavailableText = `(${I18n.translate("js.modules.support.urgent_issue_talk_to_groupon")} ${I18n.translate("js.modules.support.phone_availability")})`
    return (
      <span>
        {I18n.translate("js.modules.support.or")}&nbsp;
        <span id="callback_link" class={!phoneConfig.isAvailable ? 'channel-text-unavailable' : 'channel-text-available'} aria-label="PhoneLink" data-bhw={phoneConfig.bhw + "_link"} onClick={this.open}>
          request a call
        </span>&nbsp;
        {phoneConfig.isAvailable ? I18n.translate("js.modules.support.with_our_team") : unavailableText}
      </span>
    );
  }

  getPhoneLinkEmailButtonLayout(phoneConfig){
    let unavailableText = `(${I18n.translate("js.modules.support.urgent_issue_talk_to_groupon")} ${I18n.translate("js.modules.support.phone_availability")})`
    return (
      <span>
        <span id="callback_link" class={!phoneConfig.isAvailable ? 'channel-text-unavailable' : 'channel-text-available'} aria-label="PhoneLink" data-bhw={phoneConfig.bhw + "_link"} onClick={this.open}>
          {I18n.translate("js.modules.support.request_a_call")}
        </span>&nbsp;
        {phoneConfig.isAvailable ? I18n.translate("js.modules.support.with_our_team") : unavailableText}
      </span>
    );
  }

  render() {
    if(this.props.params){
      let phoneConfig = this.props.params.contactChannels.phone;
      let shouldShowEmailButtonLayout = this.props.params.shouldShowEmailButtonLayout;
      let  showNewChannelLayoutInWeb2018 = this.configFromDom.showNewChannelLayoutInWeb2018;
      if (phoneConfig) {
        return (
          <div>
            { showNewChannelLayoutInWeb2018 && !shouldShowEmailButtonLayout ? this.getPhoneLink(phoneConfig) : this.getPhoneLinkEmailButtonLayout(phoneConfig)}
            { this.state.open ? (
              <Portal into="body">
                <div class={'click-to-call-popup new-channel-experience'}>
                  <Click2CallFormMainContainer
                    contactChannelParams = {this.props.contactChannelParams}
                    resetState = {this.state.resetState}
                    handleClick = {this.handleClick}
                    guestOrder = {this.props.guestOrder}
                  />
                </div>
                <div class = "shadow"></div>
              </Portal>
            ): null
            }
            {this.state.confirmationPopup ? (
              <Portal into= "body">
                <div class="popup">
                 <ConfirmationPopup handleCloseConfirmationPopup = {this.handleCloseConfirmationPopup} handleBackButtonClick = {this.handleBackButtonClick}
                                    handleCloseButtonClick = {this.handleCloseButtonClick} translationObject = {this.getTranslationObject()} />
                </div>
                <div class = "shadow"></div>
              </Portal>
            ): null
            }
          </div>
        )
      }
    }
    return null;
  }
}

module.exports = CallbackView
